import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExcerptPipe } from './excerpt.pipe';
import { GetValueByKeyPipe } from './get-value-by-key.pipe';
import { RelativeTimePipe } from './relative-time.pipe';
import { NullEmptyToDashPipe } from './null-empty-to-dash.pipe';
import { CurrencyWordsPipe } from './currency-words.pipe';
import { ConvertToLocalTimePipe } from './ConvertToLocalTime.pipe';
import { ConvertToUTCTimePipe } from './ConvertToUTCTime.pipe';
import { Utils } from '../utils';

@Pipe({ name: 'phone' })
export class PhonePipe implements PipeTransform {
  transform(value: any): string {
    return Utils.formatPhone(value);
  }
}

const pipes = [
  ExcerptPipe,
  GetValueByKeyPipe,
  RelativeTimePipe,
  NullEmptyToDashPipe,
  CurrencyWordsPipe,
      ConvertToLocalTimePipe,
      ConvertToUTCTimePipe,
      PhonePipe,
   ];

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: pipes,
  exports: pipes
})
export class SharedPipesModule { }
